import React from "react";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import BeliefBreak from "../../components/BeliefBreak/BeliefBreak";
import VisualProof from "../../components/VisualProof/VisualProof";
import B2BBenefits from "../../components/B2BBenefits/B2BBenefits";
import HowItWorks from "../../components/HowItWorks/HowItWorks";
import ProductCatalog from "../../components/ProductCatalog/ProductCatalog";
import SocialProof from "../../components/SocialProof/SocialProof";
import Logistics from "../../components/Logistics/Logistics";
import FAQSection from "../../components/FAQSection/FAQSection";
import FinalCTA from "../../components/FinalCTA/FinalCTA";
import FloatingWhatsApp from "../../components/FloatingWhatsApp/FloatingWhatsApp";
import "./Home.css";

function Home() {
  return (
    <main>
      <Header />
      <Hero />
      <BeliefBreak />
      <VisualProof />
      <B2BBenefits />
      <HowItWorks />
      <ProductCatalog />
      <SocialProof />
      <Logistics />
      <FAQSection />
      <FinalCTA />
      <FloatingWhatsApp />
    </main>
  );
}

export default Home;